import { RouterLinkType } from "Enums/RouterLinkType";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import styles from "./RouterLink.scss";

interface IProps extends RouteComponentProps<any, any> {
    type: RouterLinkType;
    to: string;
    className?: string;
    children?: React.ReactNode;
}

const navigate = (props: IProps): string => {
    let navigateTo = "";

    switch (props.type) {
        case RouterLinkType.default:
            navigateTo = props.to;
            break;
        case RouterLinkType.forward:
            navigateTo = `${props.location.pathname}/${props.to}`;
            break;
    }

    return navigateTo;
};

const RouterLink: React.FunctionComponent<IProps> = (props: IProps) => {
    return (
        <Link to={navigate(props)} className={`${styles.link} ${props.className}`}>
            {props.children}
        </Link>
    );
};

export default withRouter(RouterLink);


// WEBPACK FOOTER //
// ./src/Components/RouterLink/RouterLink.tsx